import { Valence } from '../../../../../../../../../../common/model/types';
import { useImpactChartContext, useImpactChartHeights, useImpactChartWidths } from '../../../context';
import { ImpactRowBar } from './bar';
import { ImpactRowLeftPart } from './left-part';
import { ImpactRowMiddlePart } from './middle-part';
import { ImpactRowProps } from './types';

export function ImpactRow(props: ImpactRowProps) {
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const { data } = useImpactChartContext();

  const showLine = data.length > 1;
  return (
    <g>
      <ImpactRowLeftPart {...props} />
      {data.map((_d, index) => {
        const y =
          index * (heights.impactRowBarHeight + heights.impactRowSeriesSpacing) + heights.impactRowBarHeight / 2;
        return (
          <g key={index} transform={`translate(0, ${y})`}>
            <ImpactRowMiddlePart {...props} index={index} />
            <ImpactRowBar {...props} valence={Valence.NEGATIVE} index={index} />
            <ImpactRowBar {...props} valence={Valence.POSITIVE} index={index} />
          </g>
        );
      })}
      <g transform={`translate(0, -${heights.impactsSpacing / 2})`}>
        {showLine && <line x1={widths.titleTextPadding} x2={widths.full} stroke="#f9f9f9" strokeWidth={1} />}
      </g>
    </g>
  );
}
